<div class="ch-panel-content-wrapper" #chatPanel>
  <div class="search-bar" [hidden]="!searchMode">
    <div class="search-bar-input-wrapper">
      <label
        class="search-bar-input"
        [hidden]="searchResultsMode || jumpedToMessage"
      >
        <i class="feather search"></i>
        <input
          type="text"
          [(ngModel)]="searchText"
          #searchInput
          placeholder="Search messages"
        />
      </label>
      <div
        class="search-response"
        [hidden]="!searchResultsMode || jumpedToMessage"
      >
        @if (found_messages.length > 0) {
          <span>{{ found_messages.length }} </span>
        }
        @if (found_messages.length == 0) {
          <span>No </span>
        }
        result
        @if (found_messages.length > 1) {
          <span>s</span>
        }
        found for “<strong>{{ searchText }}</strong
        >”
      </div>
      <div
        class="search-response"
        [hidden]="!jumpedToMessage"
        (click)="backToSearchResults()"
      >
        <a><i class="feather arrow-left"></i> Back to Search Results</a>
      </div>
    </div>
    <div class="search-bar-button-wrapper">
      @if (!searchResultsMode && !jumpedToMessage) {
        <button class="btn btn-link" (click)="get_all_history()">Search</button>
      }
      @if (
        (searchResultsMode && !jumpedToMessage) ||
        (jumpedToMessage && !searchResultsMode)
      ) {
        <button class="btn btn-link" (click)="doneSearching()">Done</button>
      }
    </div>
  </div>

  <div
    class="ch-panel-content-scrollable-wrapper scrollbars"
    [ngStyle]="conversationArchived && { 'padding-top': '60px' }"
  >
    <div class="ch-panel-content-scrollable" #scrollMe>
      <div class="chat-wrapper-v4">
        @if (
          conversation?.messages?.length % 100 == 0 &&
          conversation?.messages?.length > 0 &&
          !searchMode &&
          currentMessageFilter == "all"
        ) {
          <div class="load-messages-wrapper">
            <a class="btn btn-primary-light" (click)="loadMoreMessages()"
              >Load earlier messages</a
            >
          </div>
        }
        @if (conversation !== undefined) {
          <div class="scrollbars">
            @for (f of found_messages; track f) {
              <div class="search-result" [hidden]="!searchResultsMode">
                @if (f.previous !== null) {
                  <div class="bubble-component">
                    <message-bubble
                      [message]="f.previous"
                      [user]="f.previous.sent_by"
                      [isSearchMode]="searchResultsMode"
                    ></message-bubble>
                  </div>
                }
                @if (f.item !== null) {
                  <div class="bubble-component" class="keyword-found">
                    <message-bubble
                      [message]="f.item"
                      [user]="f.item.sent_by"
                      [isSearchMode]="searchResultsMode"
                    ></message-bubble>
                  </div>
                }
                @if (f.next !== null) {
                  <div class="bubble-component">
                    <message-bubble
                      [message]="f.next"
                      [user]="f.next.sent_by"
                      [isSearchMode]="searchResultsMode"
                    ></message-bubble>
                  </div>
                }
                <br style="clear: both" />
                <a
                  class="text-center jump-to-conversation"
                  (click)="jumpToMessage(f.item)"
                  >Jump to message <i class="feather arrow-up-right"></i
                ></a>
              </div>
            }
            @for (
              message of currentMessageFilter == "all"
                ? conversation.messages
                : filteredMessages;
              track message.id;
              let isLast = $last
            ) {
              <message-bubble
                [hidden]="searchResultsMode"
                [message]="message"
                id="bubble-{{ message.id }}"
                #bubble
                [user]="user"
                [conversation_uuid]="conversation.uuid"
                [isLast]="isLast"
                [company_uuid]="company_uuid"
              >
              </message-bubble>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>

<!-- Upload modal -->
<div
  class="ch-panel-content-no-scroll"
  style="position: relative"
  [ngClass]="{ 'is-loading': upload_loading, hidden: conversationArchived }"
>
  @if (upload_loading) {
    <div class="upload-loading">
      <div>
        <img src="assets/img/ajax-loader.gif" alt="Loading" /> <br />Uploading
        file...
      </div>
    </div>
  }
  <div class="upload-wrapper" 
       *ngIf="showDropzone"
       appDragDrop
       (onFileDropped)="handleFiles($event)"
       (click)="chatFile.click()">
       <button
       *ngIf="showDropzone"
       type="button"
       class="btn btn-default close-dropzone-btn"
       (click)="cancelDropzone($event)">
       Cancel
     </button>
    <div class="drop-zone-content text-center p-4" [ngClass]="{ 'pt-0': has_file }">
      <i class="feather upload-cloud" style="font-size: 24px;"></i>
      <p>Drag & Drop your files or click here to select</p>
    </div>
    @if (has_file) {
      <div class="files-preview">
        @for (file of files; track file.name) {
          <div
            class="file-upload-preview generic {{ getFileExtension(file.name) }} ext-{{ getFileExtension(file.name).toLowerCase() }}"
            [style.background-image]="['jpg', 'jpeg', 'gif', 'png'].includes(getFileExtension(file.name)) && file.preview ? 'url(' + file.preview + ')' : null"
            [ngClass]="{ 'non-image': !(['jpg', 'jpeg', 'gif', 'png'].includes(getFileExtension(file.name))) }"
            (click)="$event.stopPropagation()"
          >
            <div *ngIf="!['jpg', 'jpeg', 'gif', 'png'].includes(getFileExtension(file.name))" class="file-ext-badge">
              {{ getFileExtension(file.name).toUpperCase() }}
            </div>
            <div class="file-name">{{ file.name }}</div>
            <button class="remove-uploaded-file" (click)="$event.stopPropagation(); removeFile(file)">
              <i class="feather x"></i>
            </button>
          </div>
        }
      </div>
    }
  </div>

  @if (replyingTo != null) {
    <div class="reply-preview-wrapper">
      <div class="reply-preview-content">
        <div class="reply-preview-name">{{ replyingTo.sent_by.full_name }}</div>
        <div class="reply-preview-message">{{ replyingTo.message }}</div>
      </div>
      <div class="reply-preview-action" (click)="replyingTo = null">
        <button class="cancel-reply">
          <i class="feather x"></i>
        </button>
      </div>
    </div>
  }

  <div
    class="chat-input-wrapper"
    [ngClass]="{ 'no-text': message === '' && has_file == false }"
  >
    <textarea
      class="form-control chat-input"
      rows="1"
      autosize
      #inputMessage
      (keydown.enter)="$event.preventDefault(); send_message()"
      (focus)="readConversation(); isFocused = true"
      (blur)="isFocused = false"
      [(ngModel)]="message"
      autofocus
      placeholder="Type a message. Shift+Enter adds a line."
    ></textarea>
    <div class="feather paperclip chat-file top-0" (click)="toggleDropzone()"></div>
    <input
        #chatFile
        type="file"
        multiple
        accept=".pdf,.doc,.docx,.pptx,.ppt,.xls,.xlsx,.csv,.txt,.rtf,.html,.zip,.mp3,.wma,.mpg,.flv,.avi,.jpg,.jpeg,.png,.gif,.ofx,.qbo,.iif,.qbx,.qbm,.qbb,.qbw"
        (change)="fileChange($event)"
        style="display: none"
    />
    @if (has_file) {
      <div
        role="tooltip"
        style="
          background: #151c29;
          color: #fff;
          pointer-events: none;
          display: block;
          top: auto;
          left: auto;
          right: -19px;
          animation-duration: 300ms;
          animation-delay: 1s;
          position: absolute;
          top: -20px;
        "
        class="animated fadeInDown popover in popover-top bs-popover-top top show"
      >
        <div class="popover-content popover-body" style="padding: 4px 10px; color: #fff;">
          Click to send
        </div>
      </div>
    }
    <i
      class="tio-send send animated infinite d-flex align-items-center top-0 pe-4 me-1"
      [ngClass]="{ tada: has_file }"
      (click)="send_message()"
    ></i>
  </div>
</div>
